(() => {
  const init = (root) => {
    const contentNode = root.querySelector('[data-cs-audience-content]');
    if (!contentNode) return;

    let content;
    try {
      content = JSON.parse(contentNode.textContent);
    } catch (_) {
      return;
    }

    const buttons = [...root.querySelectorAll('[data-cs-audience]')];
    const tags = root.querySelector('[data-cs-tags]');
    const eyebrow = root.querySelector('[data-cs-copy="eyebrow"]');
    const heading = root.querySelector('[data-cs-copy="heading"]');
    const description = root.querySelector('[data-cs-copy="description"]');
    const submitLabel = root.querySelector('[data-cs-submit-label]');

    const selectAudience = (audience) => {
      const selected = content[audience];
      if (!selected) return;

      buttons.forEach((button) => {
        const active = button.dataset.csAudience === audience;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-checked', String(active));
      });

      if (tags) tags.value = `newsletter, ChillSwap Waitlist, ${audience}`;
      if (eyebrow) eyebrow.textContent = selected.eyebrow;
      if (heading) heading.innerHTML = selected.heading;
      if (description) description.textContent = selected.description;
      if (submitLabel) submitLabel.textContent = audience === 'Business' ? 'CONNECT WITH OUR TEAM' : 'GET EARLY ACCESS';
    };

    buttons.forEach((button) => button.addEventListener('click', () => selectAudience(button.dataset.csAudience)));
  };

  document.querySelectorAll('[data-chillswap-password]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-chillswap-password]');
    if (root) init(root);
  });
})();
